export const initFormValidate = {
  storeName: "",
  imgLecienceUrl: "",
  lecienceCode: "",
  lecienceName: "",
  certificateType: "00",
  orginizeCode: "",
  taxlienceType: "",
  shopInImg: "",
  businessMobile: "",
  contractPerson: "",
  contactMobile: "",
  retType: "",
  tradeType: [],
  fblImgUrl: null,
  receivePerson: "",
  receiveMobile: "",

  storeArea: [],
  storeAreaName:"",
  basicStoreArea: [],

  receiveAddr: "",
  refereeCode: "",
  shopHeadImg: "",
  shopNumImg: "",
  dealerCode: "",
  fblCode: "",
  channelCode: "",

  bankAccount: "",
  bankName: "",
  companyAddress: "",
  invoiceCompany: "",
  invoiceMobile: "",
  invoiceNumber: "",

  platformCode: "",
  serviceCode: "",
  storeArea: [],
  storeClass: "GT",
  zipCode: "",

  parentCode: "",
  canOrder: "",
  groupCode: "",
  erpCode: "",
  planAccount: "",
  userType: "",
  street: "",
  classification: "imbs",
  storeAddress: "",
  atpids:[],
  atnames:"",
};

export const ruleValidate = {
  storeName: [{ required: true, message: "请输入门店名称", trigger: "blur" }],
  fblImgUrl: [{ required: true, message: "请上传食品许可证" }],
  shopInImg: [{ required: true, message: "请上传店内照片" }],
  shopNumImg: [{ required: true, message: "请上传门牌号照片" }],
  imgLecienceUrl: [{ required: true, message: "请上传营业执照照片" }],
  platformCode: [
    { required: true, message: "请选择平台编码", trigger: "change" }
  ],
  lecienceCode: [
    { required: true, message: "请输入营业执照编码", trigger: "blur" }
  ],
  lecienceName: [
    { required: true, message: "请输入营业执照名称", trigger: "blur" }
  ],
  channelCode: [{ required: true, message: "请输入渠道编码", trigger: "change" }],
  certificateType: [
    {
      required: true,
      message: "请选择认证类型",
      trigger: "change"
    }
  ],
  orginizeCode: [
    { required: true, message: "请输入组织机构代码编码", trigger: "blur" }
  ],
  taxlienceType: [
    { required: true, message: "请输入税务登记证编码", trigger: "change" }
  ],
  businessMobile: [
    { required: true, message: "请输入业务员手机号", trigger: "blur" },
    { pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur" }
  ],
  contactPerson: [
    { required: true, message: "请输入联系人", trigger: "blur" }
  ],
  contactMobile: [
    { required: true, message: "请输入联系人手机号", trigger: "blur" },
    { pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur" }
  ],
  receivePerson: [{ required: true, message: "请输入联系人", trigger: "blur" }],
  receiveMobile: [
    { required: true, message: "请输入联系人手机号", trigger: "blur" },
    { pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur" }
  ],
  storeArea: [{ required: true, type:'array', message: "请选择所属地区" }],
  storeAddress: [
    { required: true, message: "请输入详细地址", trigger: "blur" }
  ],
  atpids: [
    { required: true, type:'array', message: "请选择所属地区" , trigger: "change" }
  ],
  receiveAddr: [{ required: true, message: "请输入详细地址", trigger: "blur" }]
};



// WEBPACK FOOTER //
// ./src/views/store/validate/rule.js